<template>
  <div class="lista-aste">
    <div
      v-if="lista == null"
      class="d-flex justify-center"
      style="height: 50px"
    >
      <v-progress-circular
        indeterminate
        class="navy--text"
      ></v-progress-circular>
    </div>

    <div v-else-if="lista && _.size(lista) > 0">
      <v-list
        id="lista"
        class="overflow-y-auto pa-4"
        :class="{ 'nice-scroll': !is_mobile }"
      >
        <!-- https://stackoverflow.com/questions/56449591/what-key-to-use-for-v-for-when-elements-have-no-id -->
        <v-list-item
          class="list-item con-ombra"
          v-for="(squadraWithAsta, squadra_id) in lista"
          :key="squadra_id"
        >
          <img
            class="mr-2"
            :src="squadraWithAsta.pic"
          />
          <v-list-item-content class="text-left">
            <v-list-item-title
              ><div class="font-weight-bold white--text">
                {{ squadraWithAsta.name }}
              </div>
            </v-list-item-title>
            <v-list-item-subtitle>{{
              squadraWithAsta.astaInfo.name
            }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              depressed
              small
              class="primary"
              @click="gotoAsta(squadraWithAsta.astaInfo.id)"
            >
              Apri <v-icon right>chevron_right</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>
    <div class="lista-vuota py-4" v-else>
      <div class="navy--text">
        <div>
          <v-icon class="navy--text">shield </v-icon>
          <v-icon class="navy--text">shield </v-icon>
          <v-icon class="navy--text">shield </v-icon>
          <v-icon class="navy--text">shield </v-icon>
        </div>
        <h3>Nessuna asta.</h3>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";

export default {
  name: "lista-aste",
  mixins: [mixins],
  data() {
    return {
      // listaAste: null,
      lista: null,
    };
  },
  mounted() {
    this.loadInputs();
    console.log("--> listaAste mounted.");
  },
  destroyed() {
    console.log("<-- listaAste destroyed.");
  },

  methods: {
    async loadInputs() {
      let lista = [];
      let userAsteId = await db.getUserAsteId(this.user_uid);
      for (const [index, userAstaId] of userAsteId.entries()) {
        let mySquadra = await db.getSquadra(userAstaId, this.user_uid);
        if (!mySquadra) continue;
        let astaInfo = await db.getAstaInfo(userAstaId);
        mySquadra.astaInfo = astaInfo;
        lista.push(mySquadra);
      }
      this.lista = lista;
    },

    gotoAsta(asta_id) {
      this.$router.push({ name: "asta", params: { id: asta_id } });
    },
  },
};
</script>
<style lang="scss" scoped>
.lista-vuota {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.lista-aste {
  width: 100%;
  #lista {
    background: transparent;
    .list-item {
      margin-bottom: 10px;
      border-radius: 10px;
      padding: 15px;
      background: rgba(255, 255, 255, 0.12);
      img {
        width: 40px;
        border-radius: 4px;
      }
    }
  }
}
</style>
